import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'translateLocationFacility',
})
export class TranslateLocationFacilityPipe implements PipeTransform {
  transform(value: string | string[]): string {
    return Array.isArray(value) ? this.transformArray(value) : this.transformString(value);
  }

  transformArray(value: string[]): string {
    return value
      .map(facility => this.getLocationFacilityNameFromString(facility))
      .sort()
      .join(', ');
  }

  transformString(value: string): string {
    return this.getLocationFacilityNameFromString(value);
  }

  getLocationFacilityNameFromString(facilityString: string): string {
    return LOCATION_FACILITY_NAMES_BY_STRING[facilityString] || facilityString;
  }
}

const LOCATION_FACILITY_NAMES_BY_STRING: Record<string, string> = {
  Hotel: 'Hotel',
  Restaurant: 'Restaurant',
  Cafe: 'Café',
  Mall: 'Indkøbscenter',
  Supermarket: 'Supermarked',
  Sport: 'Sport',
  RecreationArea: 'Fritidsområde',
  Nature: 'Natur',
  Museum: 'Museum',
  BikeSharing: 'Delecykler',
  BusStop: 'Busstoppested',
  TaxiStand: 'Taxaholdeplads',
  TramStop: 'Sporvognsstoppested',
  MetroStation: 'Metrostation',
  TrainStation: 'Banegård',
  Airport: 'Lufthavn',
  ParkingLot: 'Parkeringsplads',
  CarpoolParking: 'Delebilsparkering',
  FuelStation: 'Tankstation',
  Wifi: 'Wifi',
};
